<script lang="ts">
  import { fly } from 'svelte/transition';
  import { reiniciarPasos } from '@/lib/estado/pasos';
  import { prefersReducedMotion } from 'svelte/motion';

  function manejarReinicio(): void {
    if (prefersReducedMotion.current) {
      window.location.reload();
    } else {
      // Fade-out suave antes del reload
      const cuerpo = document.body;
      cuerpo.style.transition = 'opacity 300ms';
      cuerpo.style.opacity = '0';
      setTimeout(() => window.location.reload(), 320);
    }
    reiniciarPasos();
  }
</script>

<button
  type="button"
  class="pregunta"
  onclick={manejarReinicio}
  in:fly={{ y: 30, duration: 700, delay: 1200 }}
>
  Sigamos cultivando nuestro amor
</button>

<style>
  .pregunta {
    display: block;
    margin: var(--espacado-l) auto;
    padding: 18px 36px;
    border: 1px solid var(--color-texto-carta);
    background: transparent;
    color: var(--color-texto-carta);
    font-family: var(--familia-tipografica);
    font-size: 1.125rem;
    font-style: italic;
    letter-spacing: 0.04em;
    border-radius: 0;
    cursor: pointer;
    transition:
      background var(--duracion-rapida),
      color var(--duracion-rapida);
  }

  .pregunta:hover {
    background: var(--color-texto-carta);
    color: var(--color-cielo-papel);
  }
</style>
